import "./bio.scss";
import Circle from "../SVG/Circle";
import Underline from "../SVG/Underline";
const Bio = () => {
  return (
    <section className="bio">
      <div className="text-container">
        <p className="text tag">Energiek, Interactief & Enthousiast</p>
        <div className="sub-tag-container">
          <p className="sub-tag">nice to meet you</p>
        </div>
        <div className="text head">
          “Als &nbsp;
          <span className="circle-text">
            jij &nbsp;
            <div className="circle">
              <Circle />
            </div>
          </span>
          verandert, &nbsp;
          <span className="underline-text">
            verandert &nbsp;
            <div className="underline">
              <Underline />
            </div>
          </span>
          alles”
        </div>
        <div className="bio-container">
          <p className="text-bio">
            Wat fijn dat jij hier bent! Dan kan ik je namelijk met trots laten
            zien wat ik allemaal doe. In het kort: het leven gemakkelijker maken
            voor de mensen die ik tegenkom. Dat doe ik met boeken, trainingen,
            lezingen en individuele coachingstrajecten.
          </p>
          <p className="text-bio">
            Ik geloof dat openheid en plezier maken zorgen voor een grotere
            leeropbrengst. Ik deel daarom zonder gêne eigen lachwekkende,
            tenenkrommende en ontroerende voorbeelden van hoe ik het ab-so-luut
            onhandig heb aangepakt in het leven. Dat werkt voor deelnemers en
            lezers uitnodigend om ook meer te delen.
          </p>
          <p className="text-bio">
            Mijn achtergrond in psychologie en communicatie komt altijd terug in
            wat ik doe. Ik ben dol op wetenschappelijke onderzoeken en modellen
            en behandel deze graag zo concreet mogelijk.
          </p>
          <p className="text-bio">
            Of je nou iets van me leest, een training of lezing bijwoont of met
            me spart tijdens coachingssessies; je gaat met nieuwe ideeën en een
            lach op je gezicht naar buiten.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Bio;
